module.exports = __webpack_public_path__ + "static/media/subjects-master-logo.f84639cc.svg";